export default "__VITE_ASSET__DkmKbIF1__"